export enum AuthenticationScheme {
  DEV = 'DEV',
  DEPSSO = 'DEPSSO',
  CIPM3 = 'CIPM3',
  CIPM4 = 'CIPM4',
}
